import request from '@/config/axios'

export interface LiveProjectVO {
  id?: number
  ipTitle?: string
  ipImage?: string
  ipDesc?: string
  state?: number
}

export const pageProject = (params: any) => request.get({ url: '/live/project/page', params })
export const getProject = (id: number) =>
  request.get({ url: '/live/project/get', params: { id } })
export const createProject = (data: LiveProjectVO) =>
  request.post({ url: '/live/project/create', data })
export const updateProject = (data: LiveProjectVO) =>
  request.put({ url: '/live/project/update', data })
export const deleteProject = (id: number) =>
  request.delete({ url: '/live/project/delete', params: { id } })
